import { render } from "./attachmentUploader.vue?vue&type=template&id=ba98518c&scoped=true&ts=true"
import script from "./attachmentUploader.vue?vue&type=script&lang=ts"
export * from "./attachmentUploader.vue?vue&type=script&lang=ts"

import "./attachmentUploader.vue?vue&type=style&index=0&id=ba98518c&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba98518c"]])

export default __exports__